module.exports = __webpack_public_path__ + "static/media/home.328bdf60.jpg";